import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Upload } from 'antd';

import moment from 'moment';
import dayjs from 'dayjs';
import {
    UploadOutlined
} from "@ant-design/icons";
import { MemberService } from '../../services/MemberService';
// import 'ckeditor5/ckeditor5.css';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, List } from 'ckeditor5';


interface Props {
    coupons: Array<any>
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();

    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
        })

    }, [props?.record])


    const onFinish: FormProps["onFinish"] = async (values) => {


        const data = {
            customer_level_id : props?.record?.customerLevel?.id,
            coupon_id: values.coupon_id,
            total: values.total
        }


        // if (props?.record?.id) {
        //     var res = await CouponService.updateCouponCode(data, props.record.id)
        // } else {
        var res = await MemberService.saveCustomerLevelReward(data)
        form.resetFields();
        // }

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const handleChange = (value: string) => {
        console.log(`selected ${value}`);
        form.setFieldValue('coupon_id', value)
    };


    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    coupon_id: null,
                    total: 1
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >



                <Form.Item
                    label="Coupon"
                    name="coupon_id"
                    rules={[{ required: true, message: 'Please select coupon' }]}
                >
                    <Select
                        placeholder="Please select Coupon"
                        style={{ width: 250 }}
                        onChange={handleChange}
                        options={props.coupons}
                    />
                </Form.Item>

                <Form.Item
                    label="Total"
                    name="total"
                    rules={[{ required: true, message: 'Please fill total' }]}
                >
                   <InputNumber min={1} max={10} disabled></InputNumber>
                </Form.Item>




                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
